import { render, staticRenderFns } from "./AccidentAnalysis.vue?vue&type=template&id=aa04f0ca&scoped=true&"
import script from "./AccidentAnalysis.vue?vue&type=script&lang=js&"
export * from "./AccidentAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./AccidentAnalysis.vue?vue&type=style&index=0&id=aa04f0ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa04f0ca",
  null
  
)

export default component.exports